import { render, staticRenderFns } from "./ActionListForm.vue?vue&type=template&id=2b3a5a16"
import script from "./ActionListForm.vue?vue&type=script&lang=js"
export * from "./ActionListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports